import React from 'react';

// Same mandatory-update prompt as the previous home page, in the new page's style.
export default function UpdateRequired({ onUpdate }) {
  return (
    <div className="lp-modal" role="dialog" aria-modal="true" aria-labelledby="lp-update-title">
      <div className="lp-modal-card">
        <div id="lp-update-title" className="lp-d" style={{ fontSize: '22px', fontWeight: 700, color: '#0B1B3F' }}>
          Update required
        </div>
        <p style={{ fontSize: '16px', color: '#33405E' }}>
          A new version of LegalApp is available. To continue, please get the latest version.
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button type="button" className="lp-btn lp-btn-primary lp-btn-sm" onClick={onUpdate}>
            Get latest version
          </button>
        </div>
      </div>
    </div>
  );
}
